<template>
    <div class="what_zhima">
        <Header tit="什么是芝麻信用" color="1"></Header>
        <div class="container margin-t30">
            <div class="page">
                <div class="header">
                    <img src="https://os.alipayobjects.com/rmsportal/dJyTlCRqRfCxUVf.png" />
                    <p
                        class="content"
                    >芝麻信用是独立的第三方信用评估与管理机构，基于用户授权的多维数据，向金融、租赁、出行、生活服务等场景提供信用服务。信用让人与人、人与商家之间的交易更简单。</p>
                </div>
                <div class="box box-1">
                    <h3 class="title">芝麻分</h3>
                    <p
                        class="txt"
                    >芝麻分是在用户授权下，对个人信息、行为偏好、履约能力、身份特质等维度综合评估得出的信用分，范围为 350-950，分数越高信用越好。较高的芝麻分有助于获得更便捷、更优质的服务。</p>
                    <img src="https://os.alipayobjects.com/rmsportal/xidrMrQSpUlavDl.png" />
                </div>
                <div class="box box-2">
                    <h3 class="title">查看芝麻分</h3>
                    <p class="txt">获得授权后，可在支付宝钱包 App 中查看，也可在部分合作商户的网站或 App 中查看。</p>
                    <p class="txt">未经授权与同意，芝麻信用不会向他人披露与你信用相关的个人信息。</p>
                    <img src="https://os.alipayobjects.com/rmsportal/dCAdDNQEShdbnmL.png" />
                </div>
                <div class="box box-3">
                    <h3 class="title">芝麻分的作用</h3>
                    <p class="txt">不同的网络服务商和金融机构可参考芝麻分，更快更准确地做出决策，为你提供更好的服务。</p>
                    <p class="txt">个人之间也可通过芝麻分了解彼此的信用水平，帮助做出更好的决定。</p>
                    <img src="https://os.alipayobjects.com/rmsportal/VGcVLnLkUMMIicS.png" />
                </div>
                <div class="box box-4">
                    <h3 class="title">提升芝麻分</h3>
                    <p
                        class="txt"
                    >信用提升是长期积累的过程，无法靠一次行为快速提高。日常应合理使用信用服务并按时履约；同时完善个人信息，也有助于更全面地评估你的信用水平。</p>
                    <img src="https://os.alipayobjects.com/rmsportal/RQDZipmgezVUrsq.png" />
                </div>
                <a
                    href="http://d.alipay.com/i/index.htm?iframeSrc=alipays%3A%2F%2Fplatformapi%2FstartApp%3FappId%3D20000118%26target%3Dcredit"
                    class="footer"
                >了解更多芝麻信用，请前往支付宝钱包客户端 &gt;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
            </div>
            <!-- CMS:信用中心cms/芝麻授权/什么是芝麻信用结束:xy/auth/whatszhima.vm -->
        </div>
    </div>
</template>
<script>
import Header from "../public/header";
export default {
    components: { Header },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
a {
    text-decoration: none;
}
h3,
p {
    margin: 0 15px;
    text-align: left;
    line-height: 25px;
    font-size: 14px;
}
h3 {
    margin: 20px 15px 5px;
    font-size: 16px;
    color: #000;
}
.page {
    color: #666;
    font-family: "Microsoft Yahei";
    font-size: 15px;
}
.header,
.footer {
    text-align: center;
}
.footer {
    height: 40px;
    line-height: 32px;
    text-align: center;
    color: #a5a5a5;
    font-size: 12px;
    display: block;
}
.header .content {
    color: #8f8f95;
}
.header img {
    width: 39%;
    margin: 10% 0 5%;
}
.header .ps {
    margin-bottom: 10px;
}
.box img {
    width: 100%;
    margin: 20px 0 10px;
}
.box .txt {
    color: #666;
}
.box-4 {
    margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/my/what_zhima.vue